const initialState = {
    params: {
        courseId: null,
        photoFolderId: null,
        photoAlbumId: null,
        photoDetailId: null,
    },
    photoFolder: {},
    photoFolders: [],
    photoAlbum: {},
    photoAlbums: [],
    course: {},
    courses: [],
    photoDetail: {},
    photoDetails: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "API_PHOTO_SET_PARAM":
            return {
                ...state,
                params: action.params,
                photoAlbum: action.photoAlbum ? action.photoAlbum : state.photoAlbum,
                photoFolder: action.photoFolder ? action.photoFolder : state.photoFolder,
                course: action.course ? action.course : state.course,
                photoDetail: action.photoDetail ? action.photoDetail : state.photoDetail,
            };
        case "PHOTO_GET_ALL_PHOTO_FOLDER":
            return {
                ...state,
                photoFolders: action.data.photoFolders,
            };
        case "PHOTO_SAVE_PHOTO_FOLDER":
            return {
                ...state,
                photoFolders: action.data.photoFolders,
            };
        case "PHOTO_DELETE_PHOTO_FOLDER":
            return {
                ...state,
                photoFolders: action.data.photoFolders,
            };
        case "PHOTO_GET_ALL_PHOTO_ALBUM":
            return {
                ...state,
                photoAlbums: action.data.photoAlbums,
            };
        case "PHOTO_SAVE_PHOTO_ALBUM":
            return {
                ...state,
                photoAlbums: action.data.photoAlbums,
            };
        case "PHOTO_DELETE_PHOTO_ALBUM":
            return {
                ...state,
                photoAlbums: action.data.photoAlbums,
            };
        case "API_PHOTO_GET_PHOTO_ALBUM_ICON":
            return {
                ...state,
                imagePhotoAlbumLink: action.data.imagePhotoAlbumLink,
            };
        case "API_ACTIVITIES_GET_ACTIVITIES_COURSE":
            return {
                ...state,
                courses: action.data.courses,
            };
        case "API_PHOTO_GET_PHOTO_DETAIL":
            return {
                ...state,
                photoDetails: action.data.photoDetails,
            };
        default:
            return state;
    }
};


export default reducer;
